<br />
<br />
<br />
<br />

<div *ngIf="article && article.htmlContent" class="m-4" [innerHTML]="article.htmlContent"></div>
